const EditOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_1683_11861"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1683_11861)">
      <path
        d="M3.75 14.25H4.69613L12.3735 6.57262L11.4274 5.6265L3.75 13.3039V14.25ZM2.625 15.375V12.8366L12.5179 2.94806C12.6313 2.84506 12.7564 2.7655 12.8934 2.70938C13.0306 2.65313 13.1743 2.625 13.3247 2.625C13.4751 2.625 13.6207 2.65169 13.7616 2.70506C13.9026 2.75844 14.0274 2.84331 14.136 2.95969L15.0519 3.88706C15.1683 3.99569 15.2512 4.12069 15.3007 4.26206C15.3502 4.40344 15.375 4.54481 15.375 4.68619C15.375 4.83706 15.3493 4.981 15.2978 5.118C15.2463 5.25513 15.1643 5.38038 15.0519 5.49375L5.16338 15.375H2.625ZM11.8922 6.10781L11.4274 5.6265L12.3735 6.57262L11.8922 6.10781Z"
        fill="#535862"
      />
    </g>
  </svg>
);

export default EditOutlined;
